import * as React from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { urlRoot } from "../../utils/helpers";
import { SEARCH } from "../../icons";
import * as colors from "../../settings/colors";
import Icon from "../Icon";

const searchHeight = 30;
const searchFontSize = 14;

const SearchWrapper = styled.div`position: relative;`;

const SearchIcon = styled(Icon)`
  position: absolute;
  left: 8px;
  top: ${(searchHeight - 24) / 2 + 2}px;
  color: ${colors.TEXT_SECONDARY};
`;

const SearchInput = styled.input.attrs({
  placeholder: "Search..."
})`
  color: ${colors.TEXT};
  font-size: ${searchFontSize}px;
  width: 180px;
  height: ${searchHeight}px;
  padding: 0 0 0 40px;
  border-radius: 50em;
  outline: none;
  border: 1px solid #c1c7cd;
  background: #fff;
  transition: width 0.2s;

  &:focus {
    width: 280px;
  }

  &::placeholder {
    color: ${colors.TEXT_SECONDARY};
  }

  &:focus::placeholder {
    color: ${colors.TEXT_TERTIARY};
  }
`;

class Search extends React.Component {
  state = {
    query: ""
  };

  search() {
    let { query } = this.state;
    query = typeof query === "string" ? query.trim() : "";

    if (query === "") {
      this.props.history.push(`${urlRoot(window.location.pathname)}/jobs`);
    } else {
      this.props.history.push(
        `${urlRoot(window.location.pathname)}/search?q=${query}`
      );
    }
  }

  handleChange = e => {
    this.setState({
      query: e.target.value
    });
  };

  handleKeyDown = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  render() {
    const { match, location, history, ...otherProps } = this.props;
    return (
      <SearchWrapper {...otherProps}>
        <SearchInput
          placeholder="Search..."
          value={this.state.query}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
        />
        <SearchIcon icon={SEARCH} />
      </SearchWrapper>
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/components/topbar/Search.js